// extracted by mini-css-extract-plugin
export default {"container":"ContextMenu-module__container--dPQbU","rectangle":"ContextMenu-module__rectangle--HIv1q"};